module.exports = __webpack_public_path__ + "img/dsci0148.6fa59367.jpg";